import React, { Fragment } from "react";
import Box from "@material-ui/core/Box";

import Layout2Frame from "app/MatxLayout/Layout2/Layout2Frame";

const AeoIntroduce = () => {

    return (
      <Fragment>
        <Layout2Frame>

        <Box p={{ xs: 2, sm: 3, md: 4 }}>
            <h4><strong>About the Program</strong></h4>
            <p>The Authorized Economic Operator (AEO) concept is based on the Customs-to-Business partnership as
              introduced by the World Customs Organization (WCO) under the SAFE Framework of Standards – 2005 and
              reviewed in 2015. The SAFE Framework of Standards aims to;</p>
            <ol>
              <li>Enhance Customs efficiency in the face of increasing volumes of trade and increasing vulnerability of
                the international trade supply chain to security threats by shifting the perspective from focusing on
                the goods themselves to the trader; and</li>
              <li>Facilitate Compliant traders under the programme which are accorded AEO status and considered to be
                low risk companies that can be trusted by Customs and Cross-Border Regulatory Agencies. As such,
                consignments of such companies are handled with less controls compared to others and the companies are
                granted other benefits to encourage continued voluntary compliance.</li>
            </ol>
            <p>A company or entity accredited under this programme is recognized in all EAC Partner States, and
              qualifies for benefits under the program.</p>
            <h4><strong>Categories of AEO</strong></h4>
            <p>Enrolment to the program is voluntary and free. It is open to all operators along the supply chain such
              as Traders (Importers/Exporters/Manufacturers), Customs agents, Transporters, Warehouse operators.
            </p><h4><strong>Benefits under the Program</strong></h4>
            <p>Some of the beneftis granted under the program include ...</p>
            <h4><strong>Joining the Program</strong></h4>
            <ol>
              <li><strong>On-Boarding:</strong> Request for temporary access to the RAEO Digital Platform by <a href="/session/signup" style={{color:"#DA291C",textDecoration: "underline"}}>sending a
                  sign-up request by clicking here</a>. Customs will review your request and if the preliminary
                information is adequate, you will receive a link via email to enable you to create an account.</li>
              <li><strong>Application and Self-Assessment:</strong> Fill in the self-assessment form online and provide other required
                documents;</li>
              <li><strong>Validation:</strong> Customs Administration where your company is domiciled will carry out an inspection of the
                premises and vets your application. This includes checking compliance record of the applicant in all
                Partner States</li>
              <li><strong>Approval:</strong> The Customs Administration approves the application and the Commissioner submits the
                applicant to EAC Secretariat for Authorization</li>
              <li><strong>Issuance of Certificate and Unique Identification Code:</strong> The EAC Secretariat issues a certificate and a
                unique reference code which will be used to identify the AEO and its transactions across the EAC.</li>
              <li><strong>Activation:</strong> EAC Secretariat notifies all Customs Administrations to Activate status in respective
                systems to allow the AEO access benefits.</li>
            </ol>
            <p>If you are interested to join the program,<a href="/session/signup" style={{color:"#DA291C",textDecoration: "underline"}}>signing-up for the program</a>.
          </p>
          </Box>
        </Layout2Frame>
      </Fragment>
    );
  };

export default AeoIntroduce;
